import { useState } from 'react';

export const useEmailSender = () => {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const sendEmail = async (emailData) => {
    console.log('🔍 RECEIVED emailData:', emailData);
    setSending(true);
    setError(null);

    // DEBUG: Log what we're sending
    console.log('🧵 SENDING EMAIL WITH THREADING:', {
      subject: emailData.subject,
      threadId: emailData.threadId,
      inReplyTo: emailData.inReplyTo,
      references: emailData.references
    });

    // Check for demo mode - debug what we're getting
    console.log('🔍 Environment check:', {
      VITE_EMAIL_DEMO_MODE: import.meta.env.VITE_EMAIL_DEMO_MODE,
      REACT_APP_EMAIL_DEMO_MODE: import.meta.env.REACT_APP_EMAIL_DEMO_MODE,
      all_env: import.meta.env
    });
    
    const demoMode = import.meta.env.VITE_EMAIL_DEMO_MODE === 'true' || import.meta.env.REACT_APP_EMAIL_DEMO_MODE === 'true';
    
    if (demoMode) {
      console.log('🎭 DEMO MODE: Email would be sent:', emailData);
      
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSending(false);
      
      // Simulate success
      return { success: true, message: 'Demo email sent successfully!' };
    }

    try {
      // Use production URL if running locally, or relative path if in production
      const apiUrl = window.location.origin.includes('localhost') 
        ? 'https://atomic-d8t748ov9-almgren-freshlybakeds-projects.vercel.app/api/send-email'
        : '/api/send-email';

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          subject: emailData.subject,
          from: emailData.from,
          to: emailData.to,
          cc: emailData.cc,
          content: emailData.content,
          // Threading information for proper email threading
          threadId: emailData.threadId,
          inReplyTo: emailData.inReplyTo,
          references: emailData.references
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to send email');
      }

      return { success: true };
    } catch (err) {
      console.error('Email send error:', err);
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setSending(false);
    }
  };

  return { sendEmail, sending, error };
};